import VersionHistorySegment from './VersionHistory';

export default VersionHistorySegment;
